import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import { getSourceErrorMessage } from '../../shared/sourceErrors';
import type { ChecklistEvidence, SetupRowView } from '../../tabs/setup/types';
import type { WithChecklistItemMetadata } from '../../types';
import { formatEvidenceValue, presentRowBase, warnMissingRuleText } from '../rowBase';

import { SETUP_EVIDENCE_LABELS, SETUP_RULE_TEXT, getSetupSummary } from './setupRuleText';

export function presentSetupRows(rows: Array<CmChecklist.SetupRow>): Array<WithChecklistItemMetadata<SetupRowView>> {
  return rows.flatMap((row) => {
    const ruleText = SETUP_RULE_TEXT[row.rule_id];

    if (!ruleText) {
      warnMissingRuleText(row);
      return [];
    }

    return [
      {
        ...presentRowBase(row),
        category: 'Setup',
        evidence: row.evidence.items.flatMap(presentSetupEvidenceItem),
        field: ruleText.field,
        rule: ruleText.rule,
        statusLabel: ruleText.field,
        summary: getSetupSummary(row),
      },
    ];
  });
}

function presentSetupEvidenceItem(item: CmChecklist.SetupEvidenceItem): Array<ChecklistEvidence> {
  const label = SETUP_EVIDENCE_LABELS[item.key];

  if (!label) {
    return [];
  }

  const evidence: ChecklistEvidence = item.source_error
    ? { error: true, label, value: getSourceErrorMessage(item.source, item.source_error) }
    : { label, value: formatSetupEvidenceValue(item) };

  return [item.can_override ? { canOverride: true, ...evidence } : evidence];
}

function formatSetupEvidenceValue(item: CmChecklist.SetupEvidenceItem) {
  if (Array.isArray(item.value)) {
    const joined = item.value.join(', ');

    return item.key === 'package_currencies' ? joined.toUpperCase() || '-' : joined || '-';
  }

  return formatEvidenceValue(item.value);
}
